import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
const LocationTable = ({ data, editClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  return (
    <TableContainer
      className="tableairp-responsive"
      style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
    >
      <Table className="table-airp">
        <TableHead>
          <TableRow className="laststick-tr">
            {TableHeaderName.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.airlines || "N/A"}</TableCell>
                <TableCell>{item.origins || "N/A"}</TableCell>
                <TableCell>{item.destinations || "N/A"}</TableCell>
                <TableCell>{item.blacklistAirports || "N/A"}</TableCell>
                <TableCell>
                  <p
                    className={`font-bold ${
                      item.status ? "text-success" : "text-danger"
                    }`}
                  >
                    {item.status ? "Active" : "Inactive"}
                  </p>
                </TableCell>
                <TableCell>
                  <div className="d-flex">
                    <div className="me-2">
                      <IconButton
                        aria-label="edit"
                        color="success"
                        onClick={() => editClick(item)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, page) => setPage(page)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </TableContainer>
  );
};

export default LocationTable;
const TableHeaderName = [
  "S.No.",
  "Airlines",
  "Origin",
  "Destination",
  "Blacklist Airports",
  "Status",
  "Edit",
];
